<template>
  <el-dialog title="Repay" :visible.sync="isOpen" width="10.2rem" append-to-body :close-on-click-modal="false"
    destroy-on-close>
    <div>
      <div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Outstanding :</span>
          <span class="big-num"><big-number :number="pageData.loanAmount" /></span>
          <span class="unit">TCash</span>
        </div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Collateral:</span>
          <span class="big-num2"><big-number :number="pageData.unitAmount" /></span><span class="unit"
            style="margin-bottom: -0.05rem;">UNIT</span>
        </div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Repayment Amount :</span>
          <div class="balance-box">
            <el-input v-model="inputVal" :max="maxRepaymentAmount" @blur="blurInput" @input="handleInput"><template slot="append">TCash
                Balance :<big-number :number="balance" /></template></el-input>
            <!-- <div style="color: #929DAD;font-size: 0.16rem;margin-top: 0.1rem;margin-right: 0.04rem;">Min repayment: 0.0001 TCash</div> -->
            <!-- <span class="unit">Balance : </span> -->
            <!-- <div class="min-repayment-hint">Min repayment: 0.0001 TCash</div> -->
          </div>


          <!-- <el-button type="text" style="margin-left:0.1rem;" @click="inputAll">Max</el-button> -->
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="close">Cancel</el-button> -->
      <div style="width: 100%;display: flex;justify-content: center;">
        <loading-btn type="primary" label="Repay now" @clickHandle="debounceSubmit" :disabled="isDisabled" />
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { deepClone } from "@/utils/index.js";
import { toBigNum, toBigItem, toSmallNumStr } from "@/utils/bigNumberTran.js";
import Web3 from "web3";
export default {
  data() {
    return {
      type: "1",
      isOpen: false,
      pageData: {},
      inputVal: undefined,
      balance: 0,
      web3: null,
      isSubmitting: false,
      debounceTimer: null,
      btnInstance: null
    };
  },
  computed: {
    account() {
      return this.$store.getters.metaMaskObj.account;
    },
    maxRepaymentAmount() {
      console.log('this.pageData.loanAmount', this.pageData.loanAmount);
      return toSmallNumStr(this.pageData.loanAmount);
    },
    isDisabled() {
      return !this.inputVal || parseFloat(this.inputVal) <= 0;
    }
  },
  methods: {
    open({ type, row } = {}) {
      this.type = type;
      this.isOpen = true;
      this.pageData = deepClone(row);
      this.init();
    },
    close() {
      this.isOpen = false;
      this.pageData = {};
    },
    async init() {
      this.web3 = new Web3(window.ethereum);
      this.inputVal = undefined;
      this.contractTCash = this.$store.getters.contractMap["contractTCash"].contract;
      this.contractTCashAddress = this.$store.getters.contractMap["contractTCash"].address;
      this.contractTCashLoan = this.$store.getters.contractMap["contractTCashLoan"].contract;
      this.contractTCashLoanAddress = this.$store.getters.contractMap["contractTCashLoan"].address;
      this.getBalance();
    },
    async getBalance() {
      try {
        console.log('getBalancethis.account', await this.web3.eth.getBalance(this.account));
        this.balance = await this.contractTCash.methods["balanceOf"](
          this.$store.getters.metaMaskObj.account
        ).call({
          from: this.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    handleInput(val) {
      // 确保输入值不超过最大还款金额和用户余额
      if (val) {
        const maxAmount = Math.min(
          parseFloat(this.maxRepaymentAmount),
          parseFloat(toSmallNumStr(this.balance))
        );

        if (parseFloat(val) > maxAmount) {
          this.inputVal = maxAmount.toString();
        }
      }
    },
    blurInput() {
      if (!this.inputVal) return;
      
      // 移除所有非数字字符（保留小数点）
      let cleanValue = this.inputVal.toString().replace(/[^\d.]/g, '');
      
      // 处理多个小数点的情况，只保留第一个
      const dotIndex = cleanValue.indexOf('.');
      if (dotIndex !== -1) {
        cleanValue = cleanValue.substring(0, dotIndex + 1) + cleanValue.substring(dotIndex + 1).replace(/\./g, '');
      }
      
      // 检查是否为有效数字
      if (cleanValue === '' || cleanValue === '.' || isNaN(parseFloat(cleanValue))) {
        this.inputVal = '';
        return;
      }
      
      // 转换为数字后再转回字符串，自动去掉前导零和尾随零
      const numValue = parseFloat(cleanValue);
      
      // 如果数字为0或负数，清空输入
      if (numValue <= 0) {
        this.inputVal = '';
        return;
      }
      
      // 格式化数字，避免科学计数法，去掉不必要的零
      let formattedValue;
      
      // 检查是否为科学计数法
      const numStr = numValue.toString();
      if (numStr.includes('e') || numStr.includes('E')) {
        // 如果是科学计数法，使用 toFixed 并去掉尾随零
        formattedValue = numValue.toFixed(18).replace(/\.?0+$/, '');
      } else {
        formattedValue = numStr;
      }
      
      // 检查是否超过最大还款金额和余额限制
      const maxAmount = Math.min(
        parseFloat(this.maxRepaymentAmount),
        parseFloat(toSmallNumStr(this.balance))
      );
      
      if (numValue > maxAmount) {
        const maxNumStr = maxAmount.toString();
        if (maxNumStr.includes('e') || maxNumStr.includes('E')) {
          formattedValue = maxAmount.toFixed(18).replace(/\.?0+$/, '');
        } else {
          formattedValue = maxNumStr;
        }
      }
      
      this.inputVal = formattedValue;
    },
    checkVal() {
      if (this.inputVal < 0.000001 || !this.inputVal) {
        this.$message.warning("The repayment amount cannot be less than or equal to 0.000001");
        return false;
      }
      if (toBigItem(this.inputVal).comparedTo(this.pageData.loanAmount) > 0) {
        this.$message.warning("The repayment amount cannot be greater than the total repayment amount");
        return false;
      }
      if (toBigItem(this.inputVal).comparedTo(this.balance) > 0) {
        this.$message.warning("Insufficient TCash balance");
        return false;
      }
      return true;
    },
    inputAll() {
      const maxAmount = Math.min(
        parseFloat(toSmallNumStr(this.pageData.loanAmount)),
        parseFloat(toSmallNumStr(this.balance))
      );
      this.inputVal = maxAmount.toString();
    },
    debounceSubmit(btn) {
      this.btnInstance = btn;

      // 如果已经在提交中，直接返回
      if (this.isSubmitting) {
        btn.closeLoad();
        return;
      }

      // 清除之前的定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 设置防抖延迟
      this.isSubmitting = true;
      this.debounceTimer = setTimeout(() => {
        this.save();
      }, 500); // 500ms防抖时间
    },
    async save() {
      try {
        if (!this.btnInstance) return;

        if (!this.checkVal()) {
          this.btnInstance.closeLoad();
          this.isSubmitting = false;
          return;
        }

        console.log('this.pageData', this.pageData);
        // 构建交易参数
        const txParams = {
          from: this.account,
          value: 0,
          gas: await this.estimateGas(),
          gasPrice: await this.web3.eth.getGasPrice(),
        };

        // 发送交易
        const res = await this.contractTCashLoan.methods.repay(this.pageData.loanId, toBigNum(this.inputVal)).send(txParams)
        console.log('repay transaction result:', res);

        let resData = {
          ...this.pageData,
          Unrepaid: new this.BigNumber(this.pageData.loanAmount).minus(toBigNum(this.inputVal)),
          isAll: toBigItem(this.inputVal).comparedTo(this.pageData.loanAmount) >= 0,
          // result: res,
          unitRefund: res.events.RepayRecord.returnValues.UnitAmount
        }
        this.$emit("refresh", resData);
        this.close();
        this.$message.success("You have successfully buyback TCash!");
      } catch (error) {
        console.error('Repay transaction failed:', error);
        this.$message.error(error.message || 'Repay transaction failed');
      } finally {
        if (this.btnInstance) {
          this.btnInstance.closeLoad();
          this.btnInstance = null;
        }
        // 重置提交状态
        this.isSubmitting = false;
      }
    },

    // 估算gas
    async estimateGas() {
      console.log('this.account', this.account);
      try {
        // console.log('toBigNum', toBigNum(this.inputVal));
        const estimated = await this.contractTCashLoan.methods["repay"](
          this.pageData.loanId,
          toBigNum(this.inputVal)
        ).estimateGas({
          from: this.account,
          value: 0
        });
        console.log('estimated', estimated);
        // 使用乘数增加一些额外的gas，以防止gas不足
        return Math.floor(estimated * 1.2);
      } catch (error) {
        console.error('Gas estimation failed:', error);
        // 如果估算失败，使用默认值
        return this.$store.getters.gas;
      }
    }
  },
  created() { }
};
</script>
<style scoped lang="scss">
.unit {
  font-size: 0.16rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
  margin-bottom: -0.1rem;
}

.big-num .big-number {
  color: #1F1F1F;
  font-size: .28rem;
  font-weight: 500;
}

.big-num2 .big-number {
  color: #1F1F1F;
  font-size: .2rem;
  font-weight: 500;
}

.detail-item {
  margin-bottom: 0.35rem;
}

.balance-box {
  position: relative;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &>span {
    position: absolute;
    right: 0.02rem;
    top: -0.3rem;
  }

  ::v-deep  .el-input-group {
    border-radius: 4px;
    border: 1px solid #D9DDE3;
  }

  ::v-deep  .el-input__inner {
    height: 0.48rem;
    background: transparent;
    border-color: transparent;
    // border-color:#D9DDE3;
  }

  ::v-deep  .el-input-group__append {
    background: transparent;
    border-color: transparent;
    font-size: 0.18rem;
    color: #AAAAAA;
  }
}

>>>.el-dialog__header .el-dialog__title {
  color: #1F1F1F;
  font-weight: bold;
  font-size: .28rem;
}

.min-repayment-hint {
  color: #929dad;
  font-size: 0.16rem;
  margin-top: 0.1rem;
}
</style>
